import '@/plugins/vuetify';
import store from '@/store/store';
import router from '@/router/router';
import App from '@/App.vue';
import '@/registerServiceWorker';
import Vue from 'vue';
import moment from 'moment';

Vue.filter('formatDate', (value) => {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY');
  }
  return moment().format('DD-MM-YYYY');
});
//
// Vue.use(momentRange);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
